const config = {
	api: 'https://ust-testing2.beautitag.com/path/api',
	asset: 'https://ust-testing2.beautitag.com/path/asset',
	loginTimeout: 18000000
};

export default config;
